var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutlineLock({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.10256 6.8718C7.10256 4.18118 9.28374 2 11.9744 2C14.665 2 16.8462 4.18118 16.8462 6.8718V10.2051H18.1282C19.6859 10.2051 20.9487 11.4679 20.9487 13.0256V19.1795C20.9487 20.7372 19.6859 22 18.1282 22H5.82051C4.26279 22 3 20.7372 3 19.1795V13.0256C3 11.4679 4.26279 10.2051 5.82051 10.2051H7.10256V6.8718ZM8.64103 10.2051H15.3077V6.8718C15.3077 5.03085 13.8153 3.53846 11.9744 3.53846C10.1334 3.53846 8.64103 5.03085 8.64103 6.8718V10.2051ZM5.82051 11.7436C5.11246 11.7436 4.53846 12.3176 4.53846 13.0256V19.1795C4.53846 19.8875 5.11246 20.4615 5.82051 20.4615H18.1282C18.8363 20.4615 19.4103 19.8875 19.4103 19.1795V13.0256C19.4103 12.3176 18.8363 11.7436 18.1282 11.7436H5.82051ZM11.9744 14.3077C12.3992 14.3077 12.7436 14.6521 12.7436 15.0769V17.1282C12.7436 17.553 12.3992 17.8974 11.9744 17.8974C11.5495 17.8974 11.2051 17.553 11.2051 17.1282V15.0769C11.2051 14.6521 11.5495 14.3077 11.9744 14.3077Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlineLock);
export default __webpack_public_path__ + "static/media/outline-lock.1cfde2b4774b7927f9d04ca83755e4f9.svg";
export { ForwardRef as ReactComponent };